const iframeUrl: Record<string, string> = {
    rd: 'https://morpho.bj.bcebos.com/rte-online/morpho/live-render/rd/index.html',
    qa: 'https://morpho.bj.bcebos.com/rte-online/morpho/live-render/qa/index.html',
    gray: 'https://morpho.bj.bcebos.com/rte-online/morpho/live-render/gray/index.html',
    online: 'https://morpho.bj.bcebos.com/rte-online/morpho/live-render/index.html',
};

export const iframeEnvMap: Record<string, string> = {
    local: iframeUrl.rd,
    rd: iframeUrl.rd,
    qa: iframeUrl.qa,
    gray: iframeUrl.gray,
    online: iframeUrl.online,
    'sdk.prod': iframeUrl.online,
    'sdk.gray': iframeUrl.gray,
    'sdk.qa': iframeUrl.qa,
    'sdk.rd': iframeUrl.rd,
    'sdk.dev': iframeUrl.rd,
};
